export default __webpack_public_path__ + "static/media/Sans-titre.2b260d72.png";